import { Alert } from "@interstate/components/Alert";
import { ErrorMessages } from "@coxauto-ui/cxm/communications/util";
import { StyledContainerAlert } from "./styled";

export interface TokenReplacementWarningAlertProps {
  showTokenReplacementWarning: boolean;
  onClose: () => void;
}

export function TokenReplacementWarningAlert({
  showTokenReplacementWarning,
  onClose
}: TokenReplacementWarningAlertProps) {
  if (!showTokenReplacementWarning) {
    return null;
  }

  return (
    <StyledContainerAlert>
      <Alert
        data-testid="token-replacement-warning-message-reply-app"
        displayCloseButton={true}
        role="info"
        type="info"
        onCloseClick={onClose}
      >
        <span>{ErrorMessages.TOKEN_REPLACEMENT_WARNING}</span>
      </Alert>
    </StyledContainerAlert>
  );
}
